export const ACCOUNT_TYPE = {
    SUPERADMIN: "SuperAdmin",
    ADMIN: "Admin",
    EMPLOYEE: "Employee",
    USER: "User",
  }
  
  export const NODE_STATUS = {
    DRAFT: "Draft",
    PUBLISHED: "Published",
  }